export const FETCH_RESOURCE_LOADING = 'FETCH_RESOURCE_LOADING'
export const FETCH_RESOURCE_LOADED = 'FETCH_RESOURCE_LOADED'
export const FETCH_RESOURCE_ERROR = 'FETCH_RESOURCE_ERROR '